exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-6664f7ee] {\n\tmargin-left: auto;\n\tmargin-right: auto;\n}\n.btn-light[data-v-6664f7ee] {\n\tfont-weight: normal;\n\tmargin-right: 8px;\n}\n.btn-light.btn-current[data-v-6664f7ee] {\n\tcolor: #007949;\n\tfont-weight: bold;\n}\n.dashboard-timeframe-selector-container[data-v-6664f7ee] {\n\tposition: absolute;\n\ttop: 0;\n\tright: 0;\n}\n.center[data-v-6664f7ee] {\n\tdisplay: flex;\n\tjustify-content: center;\n}\nh4[data-v-6664f7ee] {\n\tmargin-bottom: 12px;\n}\n", ""]);

// exports
